<div class="form-group mt-2">
  <div class="alert alert-danger" role="alert" *ngIf="showError">
    Unsupported File Type or Size
    <i (click)="hideAlert()" class="fa fa-close"></i>
  </div>
  <div class="file-field" [class.uploading]="attachment.uploading" *ngFor="let attachment of attachments">
    <div *ngIf="(attachment.name && (downloadOnly || attachment.uploadSuccessful))">
      <a href="javascript:void(0);" (click)="downloadAttachment(attachment)">{{attachment.name}}</a>
    </div>
    <span *ngIf="isRequired" class="text-danger file-field-required">*</span>
    <a *ngIf="!downloadOnly" href="javascript:void(0);" class="removeAttachment" (click)="removeAttachment(attachment)"><i class="fa fa-close"></i></a>
  </div>
  <div *ngIf="!downloadOnly">
    <div class="fileUploadContainer" >
      <span><i class="fa fa-spinner fa-spin"></i>Add Attachment</span>
      <input type="file" [accept]="acceptTypes" (change)="upload($event)" (click)="ensureCanReplaceSameDocument($event)">
    </div>
    <p>Acceptable: {{acceptTypesFriendlyFormat}} file types ({{sizeLimitFriendlyFormat}} MB max)</p>
  </div>
</div>
